/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import FormCondition from 'cio/app-models/conditions/form';
import { SharedFormModelInterface } from 'cio/utils/forms';
interface ConditionEditorFormComponentArgs {
  condition: FormCondition;
  disabled: boolean;
  size?: string;
}

export default class ConditionEditorFormComponent extends Component<ConditionEditorFormComponentArgs> {
  @action
  onFormChange(form: SharedFormModelInterface) {
    this.args.condition.setForm(form.formType, form.formIdLowercase);
  }
}
